import React from "react";
import "./close-icon.styles.css";

interface CloseIconProps {
  customClassName?: string;
}

const CloseIcon = ({ customClassName }: CloseIconProps): JSX.Element => {
  const className = `icon-close ${customClassName}`;
  return <div className={className} />;
};

export default CloseIcon;
